import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createPaabudEvidenceQueryKey,
  createPaabudPendingEvidenceQueryKey,
  getPendingPaabudIndberetningEvidence,
  getReportEvidenceByPaabud,
  preparePaabudIndberetningForSigning,
} from "@/api/paabudIndberetning";
import type { PendingEvidenceResponse } from "@/interfaces/indberetning";
import type { ReportEvidenceModel } from "@cle/models/reportEvidence";
import type {
  PreparePaabudIndberetningRequest,
  PreparePaabudIndberetningResponse,
} from "@/interfaces/paabudIndberetning";

export {
  createPaabudEvidenceQueryKey,
  PAABUD_INDBERETNING_QUERY_KEY,
} from "@/api/paabudIndberetning";

export const usePreparePaabudIndberetningForSigning = () =>
  useMutation<
    PreparePaabudIndberetningResponse,
    Error,
    PreparePaabudIndberetningRequest
  >({
    mutationFn: preparePaabudIndberetningForSigning,
  });

export const useReportEvidenceByPaabud = (paabudId?: string | null) =>
  useQuery<ReportEvidenceModel[]>({
    enabled: Boolean(paabudId),
    queryKey: createPaabudEvidenceQueryKey(paabudId ?? ""),
    queryFn: () => getReportEvidenceByPaabud(paabudId as string),
    staleTime: 5 * 60 * 1000,
  });

export const usePendingPaabudIndberetningEvidence = (
  indberetningId?: string | null,
) =>
  useQuery<PendingEvidenceResponse>({
    queryKey: createPaabudPendingEvidenceQueryKey(indberetningId ?? ""),
    queryFn: () =>
      getPendingPaabudIndberetningEvidence(indberetningId as string),
    enabled: Boolean(indberetningId),
    staleTime: 5 * 60 * 1000,
  });
